var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{ref:"gmap",attrs:{"id":"map","center":_vm.center,"zoom":15,"options":_vm.options,"map-type-id":"roadmap"}},[_c('gmap-marker',{attrs:{"position":_vm.center}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }